import { API_URL } from '../components/common/Config';
import { encryptPayload, normalizeEncryptedApiResponse } from './customerCrypto';
import {
  ensureCompanySettings,
  resolveCustomerApiEncrypt,
} from './companySettingsCache';

function appendPlainPayload(params, plainPayload) {
  Object.entries(plainPayload).forEach(([key, value]) => {
    if (key === 'search' && value && typeof value === 'object') {
      params.append('search[value]', value.value ?? '');
      params.append('search[regex]', value.regex ?? 'false');
    } else {
      params.append(key, value ?? '');
    }
  });
}

export function buildDatatablePayload({
  page,
  rowsPerPage,
  startDate,
  endDate,
  searchValue,
  extra = {},
}) {
  return {
    draw: String(page + 1),
    start: String(page * rowsPerPage),
    length: String(rowsPerPage),
    start_date: startDate ?? '',
    end_date: endDate ?? '',
    search: { value: searchValue ?? '', regex: 'false' },
    ...extra,
  };
}

export async function postDashboardDatatable(bearerToken, endpoint, plainPayload) {
  const settings = await ensureCompanySettings();
  const useEncrypt = resolveCustomerApiEncrypt(settings);
  const headers = { authorization: `Bearer ${bearerToken}` };
  let body;

  if (useEncrypt) {
    const ep = encryptPayload(plainPayload);
    if (!ep) {
      return { response: null, data: null };
    }
    const fd = new FormData();
    fd.append('encrypted_payload', ep);
    body = fd;
  } else {
    const params = new URLSearchParams();
    appendPlainPayload(params, plainPayload);
    headers['Content-Type'] = 'application/x-www-form-urlencoded';
    body = params.toString();
  }

  const response = await fetch(`${API_URL}/${endpoint.replace(/^\//, '')}`, {
    method: 'POST',
    headers,
    body,
  });

  let raw = null;
  try {
    raw = await response.json();
  } catch {
    raw = null;
  }
  const data = normalizeEncryptedApiResponse(raw, useEncrypt) ?? raw;
  return { response, data };
}
